import React from 'react'
// @src imports
import { UiCard } from 'src/chrome'
import { FlexColumn } from 'src/styled'
import { useAccount, useSubscriptions } from 'src/hooks'
import {
  Anchor,
  Button,
  ButtonType,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'

const twoFields: React.CSSProperties = {
  display: 'flex',
  width: '100%',
  margin: 'auto',
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'wrap',
}
interface StreamLinksCardProps {
  isAffiliate: boolean
  isSRP: boolean
}

const websiteLinks = [
  {
    title: 'www.greenerstill.com',
    href: 'https://www.greenerstill.com/',
  },
  {
    title: 'www.promptingu.com',
    href: 'https://www.promptingu.com/',
  },
  {
    title: 'www.blue42forlife.com',
    href: 'https://www.blue42forlife.com/',
  },
  {
    title: 'www.bellacadeaux.com',
    href: 'https://www.bellacadeaux.com/',
  },
  {
    title: 'www.streammarketing.com',
    href: 'https://www.streammarketing.com/',
  },
  {
    title: 'www.streamvirtualassistant.com',
    href: 'https://www.streamvirtualassistant.com/',
  },
  {
    title: 'www.sendoutcards.com',
    href: 'https://www.sendoutcards.com/',
  },
]

const subscriptionLinks = [
  {
    title: 'SendOutCards',
    domainName: 'SendOutCards',
    type: 'secondary',
  },
  {
    title: 'Prompting U',
    domainName: 'PromptingU',
    type: 'secondary',
  },
  {
    title: 'Stream Marketing',
    domainName: 'streammarketing',
    type: 'secondary',
  },
  {
    title: 'Stream Virtual Assistant',
    domainName: 'streamvirtualassistant',
    type: 'secondary',
  },
]

const StreamLinksCard: React.FC<StreamLinksCardProps> = props => {
  const account = useAccount()
  const {
    hasPromptingUSubscription,
    hasStreamMarketingSubscription,
    hasStreamVASubscription,
    hasSocSubscription,
  } = useSubscriptions()

  const streamButtons = subscriptionLinks.map(link => {
    // tslint:disable-next-line
    let linkDestination = ''
    switch (link.domainName) {
      case 'PromptingU':
        linkDestination = account.promptinguLoginUrl ?? 'https://promptingu.com'
        break
      case 'streammarketing':
        linkDestination =
          account.streamMarketingLoginUrl ?? 'https://streammarketing.com'
        break
      default:
        linkDestination = `https://www.${link.domainName}.com/`
        break
    }
    return (
      <>
        <Spacer space="x2" orientation="horizontal" />
        <Button
          title={link.title}
          size="small"
          onClick={() => window.open(linkDestination, '_blank')}
          disabled={
            (link.domainName === 'SendOutCards' && !hasSocSubscription) ||
            (link.domainName === 'PromptingU' && !hasPromptingUSubscription) ||
            (link.domainName === 'streammarketing' &&
              !hasStreamMarketingSubscription) ||
            (link.domainName === 'streamvirtualassistant' &&
              !hasStreamVASubscription)
          }
          disabledCaption="You must be a paid subscriber to use this Stream."
          type={link.type as ButtonType}
        />
      </>
    )
  })
  return (
    <UiCard style={{ width: '100%' }} title={'Stream Links'}>
      <FlexColumn
        style={{
          width: '100%',
        }}
      >
        <Spacer space="x1" />
        <div style={twoFields}>
          <Text type="body" color="primaryHeading" outset={{ top: 'x1' }}>
            Website Links:
          </Text>
          {websiteLinks.map(link => {
            return (
              <>
                <Spacer space="x2" orientation="horizontal" />
                <Anchor
                  target="_blank"
                  href={link.href}
                  title={link.title}
                  color="anchorBlue"
                  isDecorated={true}
                />
              </>
            )
          })}
        </div>
        <div style={twoFields}>
          <Text type="body" color="primaryHeading" outset={{ top: 'x1' }}>
            Subscription Links:
          </Text>
          {streamButtons}
        </div>
      </FlexColumn>
    </UiCard>
  )
}

export default StreamLinksCard
